import { requestDeleteReplay } from '@/composables/network-manager';

import type { Replay } from '@/shared/model/types/replay';
import type { BaseError } from '@/shared/model/types/api-types';

import { MAX_ATTEMPTS, RETRY_DELAY, RETRY_STATUS_CODE_LIST, ERROR_MAP } from '../config';
import type { ReplayRequest } from '../model/types';

const deleteReplay = async (id: Replay['id']): Promise<ReplayRequest> => {
  let attempt = 0;

  try {
    while (attempt < MAX_ATTEMPTS) {
      // oxlint-disable-next-line no-await-in-loop
      const { response, error } = await requestDeleteReplay(id);

      // If the request succeeded or the status code is not retryable, return the result.
      if (!error) {
        return {
          status: true,
          message: {
            title: 'Реплей удалён',
          },
        };
      }

      attempt++;

      // Wait before next retry if attempts to remain.
      if (attempt < MAX_ATTEMPTS && RETRY_STATUS_CODE_LIST.includes(response.status)) {
        // oxlint-disable-next-line no-await-in-loop
        return await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
      } else {
        const normalizeError = error as BaseError;

        if (normalizeError.details) {
          const { title = '', description } = normalizeError.details;
          return {
            status: false,
            message: {
              title,
              description,
            },
          };
        }
      }
    }
  } catch {
    throw new Error('Error deleting replay. Max retries reached.');
  }

  return ERROR_MAP.get('default') ?? { status: false };
};

export { deleteReplay };
